import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from '@/utils/api/axios';
import { IMonthlyData, IBillingFilters } from '@/components/data-display/billing-milestones/types';

interface UseBillingMilestonesProps {
  organizationId: string;
  filters: IBillingFilters;
}

interface BillingMilestonesResponse {
  docs: IMonthlyData[];
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
}

export function useBillingMilestones({
  organizationId,
  filters,
}: UseBillingMilestonesProps): UseQueryResult<IMonthlyData[], Error> {
  return useQuery({
    queryKey: ['billing-milestones', organizationId, filters],
    queryFn: async (): Promise<IMonthlyData[]> => {
      const filterData = {
        groupByMonth: true,
        search: filters.search,
        year: filters.year,
        month: filters.month,
        status: filters.status,
        pageSize: 200,
      };

      const response = await axios.post<BillingMilestonesResponse>(
        `/organizations/${organizationId}/billing`,
        filterData
      );

      return response.data.docs || [];
    },
    enabled: !!organizationId,
  });
}
